<template>

    <div>

        <div class="row">
            <div class="col-24 col-md-12">

                <h3>Uppgifter</h3>

                <div class="custom-form-section">

                    <div class="custom-form-group" :key="field.id" v-for="field in dynamic_fields" v-if="field.type !== 'password'">
                        <input-text
                            :type="field.input_type"
                            :name="'dynamic_fields_data.'+field.id+'.value'"
                            :label="field.label"
                            :required="field.is_required"
                            v-model="dynamic_fields_data[field.id].value"
                            v-if="field.type !== 'workplace_id'"
                        />
                        <input-select
                            :name="'dynamic_fields_data.'+field.id+'.value'"
                            :label="field.label"
                            :required="field.is_required"
                            v-model="dynamic_fields_data[field.id].value"
                            :options="workplaces"
                            v-if="field.type === 'workplace_id'"
                        />
                    </div>

                </div>

            </div>

            <div class="col-24 col-md-12" v-if="employee.company.employee_part_payment_type !== 'none'">

                <h3>Delbetalning</h3>

                <div class="custom-form-section">

                    <input-check-radio
                        type="checkbox"
                        name="part_payment_exception"
                        v-model="part_payment_exception"
                        form-group-class="mb-0"
                        :options="[
                            {value: 1, label: 'Ställ in eget belopp för den anställde'},
                        ]"
                    />

                    <input-text
                        type="number"
                        name="part_payment_amount"
                        label="Belopp"
                        v-model="part_payment_amount"
                        addon="kr inkl moms"
                        form-group-class="w-50"
                        v-if="part_payment_exception"
                    />

                    <div class="custom-info mb-3">Om du ändrar belopp för alla anställda på företaget, kommer inte detta att ändras. Det behöver i så fall ändra manuellt för denna personen.</div>

                </div>

            </div>

        </div>

        <div class="d-flex justify-content-end" v-if="!employee.invited_at && !employee.activated_at">
            <button class="btn btn-primary me-4" :disabled="patcher.loading" @click="patcherPatch()">
                <span class="spinner-border spinner-border-sm"></span>
                Bjud in och stanna
            </button>
            <button class="btn btn-primary ml-4" :disabled="patcher.loading" @click="patchAndNew()">
                <span class="spinner-border spinner-border-sm"></span>
                Bjud in och lägg till ny anställd
            </button>
        </div>

        <div class="d-flex justify-content-end" v-else>
            <button class="btn btn-primary" :disabled="patcher.loading" @click="patcherPatch()">
                <span class="spinner-border spinner-border-sm"></span>
                Spara
            </button>
        </div>

    </div>

</template>

<script>

import patcher from '../../../../shared/mixins/patcher'
import employeeDynamicFields from '../../../../shared/mixins/employee-dynamic-fields'
import axios from 'axios'

export default {

    mixins: [
        patcher,
        employeeDynamicFields
    ],

    props: {
        employee: {
            required: true
        },
        workplaces: {
            required: true
        },
        dynamic_fields: {
            required: true
        }
    },

    data () {
        return {
            createNewOnPatch: false,
            part_payment_exception: this.employee.part_payment_exception,
            part_payment_amount: this.employee.part_payment_amount
        }
    },

    created () {
        this.resetDynamicFieldData()
    },

    computed: {

        patcherUrl () {
            return '/employees/' + this.employee.id
        },

        patcherData () {
            return {
                dynamic_fields_data: this.dynamic_fields_data,
                part_payment_exception: this.part_payment_exception,
                part_payment_amount: this.part_payment_amount
            }
        }

    },

    methods: {

        patchAndNew () {
            this.createNewOnPatch = true
            this.patcherPatch()
        },

        patcherSuccess () {
            bus.$emit(
                'notify',
                'Ändringarna har sparats.'
            )
            this.$emit('refresh')
            if (this.createNewOnPatch) {
                this.$emit('createNew')
            }
        }
    }
}
</script>
